import React from "react";

import { Page } from "./Page";

import { MetaWrapper } from "../../components/Meta";

export default function ContactView() {
  return (
    <MetaWrapper
      meta={{
        title: "Piroshky Piroshky Bakery - Contact",
        description:
          "Contact Piroshky Piroshky in Pike Place, Northgate Mall, Century Square, Columbia Center or South Park",
      }}
    >
      <Page />
    </MetaWrapper>
  );
}
